(function () {
  'use strict';

  var SUPPORTS_IO = 'IntersectionObserver' in window;
  var DRAG_THRESHOLD = 8;

  function init(root) {
    if (!root || root.dataset.psReady === '1') return;
    root.dataset.psReady = '1';

    var viewport = root.querySelector('[data-viewport]');
    var rail = root.querySelector('[data-rail]');
    var original = root.querySelector('[data-set]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!rail) return;

    var playInView = root.dataset.autoplay === 'true';
    var motion = root.dataset.motion || 'off';
    var speed = parseFloat(root.dataset.speed) || 60;

    /* ---------- playback ---------- */
    function stopOthers(keep) {
      root.querySelectorAll('[data-card]').forEach(function (card) {
        if (card === keep) return;
        var v = card.querySelector('video');
        if (v && !v.paused) v.pause();
        card.classList.remove('is-playing', 'is-loading');
      });
    }

    function play(card, video, withSound) {
      stopOthers(card);
      card.classList.add('is-loading');

      if (withSound) {
        video.muted = false;
        card.classList.add('is-loud');
      }

      var p = video.play();

      if (!p || !p.then) {
        card.classList.remove('is-loading');
        card.classList.add('is-playing');
        return;
      }

      p.then(function () {
        card.classList.remove('is-loading');
        card.classList.add('is-playing');
      }).catch(function () {
        /* Browsers block sound on a first play. Retry muted. */
        video.muted = true;
        card.classList.remove('is-loud');
        video.play().then(function () {
          card.classList.remove('is-loading');
          card.classList.add('is-playing');
        }).catch(function () {
          card.classList.remove('is-loading');
        });
      });
    }

    function pause(card, video) {
      video.pause();
      card.classList.remove('is-playing', 'is-loading');
    }

    /* One place decides what a tap on a card means. */
    function handleTap(target) {
      var card = target && target.closest ? target.closest('[data-card]') : null;
      if (!card) return;

      var video = card.querySelector('video');
      if (!video) return;

      if (target.closest('[data-shop]')) return;

      if (target.closest('[data-mute]')) {
        video.muted = !video.muted;
        card.classList.toggle('is-loud', !video.muted);
        if (video.paused) play(card, video, !video.muted);
        return;
      }

      if (video.paused) {
        play(card, video, true);
      } else {
        pause(card, video);
      }
    }

    root.addEventListener('pause', function (e) {
      var card = e.target.closest && e.target.closest('[data-card]');
      if (card) card.classList.remove('is-playing', 'is-loading');
    }, true);

    root.addEventListener('playing', function (e) {
      var card = e.target.closest && e.target.closest('[data-card]');
      if (card) {
        card.classList.remove('is-loading');
        card.classList.add('is-playing');
      }
    }, true);

    /* ---------- watch cards ---------- */
    function watchCards() {
      if (!SUPPORTS_IO) return;

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var video = card.querySelector('video');
          if (!video) return;

          if (entry.isIntersecting) {
            if (playInView && video.paused && !card.classList.contains('is-loud')) {
              video.muted = true;
              video.play().then(function () {
                card.classList.add('is-playing');
              }).catch(function () {});
            }
          } else if (!video.paused) {
            pause(card, video);
            video.muted = true;
            card.classList.remove('is-loud');
          }
        });
      }, { root: null, rootMargin: '150px', threshold: 0.4 });

      root.querySelectorAll('[data-card]').forEach(function (c) { io.observe(c); });
    }

    /* ================= MANUAL MODE ================= */
    if (motion === 'off') {
      var mStartX = 0;
      var mMoved = 0;

      rail.addEventListener('pointerdown', function (e) {
        mStartX = e.clientX;
        mMoved = 0;
      });

      rail.addEventListener('pointermove', function (e) {
        if (e.buttons) mMoved = Math.abs(e.clientX - mStartX);
      });

      rail.addEventListener('click', function (e) {
        if (mMoved > DRAG_THRESHOLD) {
          mMoved = 0;
          e.preventDefault();
          return;
        }
        if (e.target.closest('[data-shop]')) return;
        e.preventDefault();
        handleTap(e.target);
      });

      function step(dir) {
        var card = rail.querySelector('[data-card]');
        var w = card ? card.offsetWidth + 12 : 200;
        rail.scrollBy({ left: dir * w * 2, behavior: 'smooth' });
      }

      function sync() {
        var scrollable = rail.scrollWidth - rail.clientWidth > 4;
        var nav = root.querySelector('[data-nav]');
        if (nav) nav.hidden = !scrollable;
        if (!scrollable) return;
        if (prev) prev.disabled = rail.scrollLeft <= 2;
        if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
      }

      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      rail.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      watchCards();
      sync();
      setTimeout(sync, 600);
      return;
    }

    /* ================= AUTO MODE ================= */
    if (!viewport || !original) return;

    var dir = motion === 'ltr' ? -1 : 1;
    var offset = 0;
    var setWidth = 0;
    var pxPerSec = 0;
    var velocity = 0;

    var down = false;
    var captured = false;
    var moved = 0;
    var lastX = 0;
    var startTarget = null;
    var lastTime = null;

    function isPaused() {
      return root.dataset.hold === '1' || !!root.querySelector('.is-playing');
    }

    function measure() {
      var w = original.getBoundingClientRect().width;
      if (w > 0) return w;
      var total = 0;
      for (var i = 0; i < original.children.length; i++) {
        total += original.children[i].getBoundingClientRect().width;
      }
      return total;
    }

    function build() {
      var w = measure();
      if (!w) return;

      setWidth = w;
      pxPerSec = w / speed;

      var vw = viewport.getBoundingClientRect().width || w;
      var need = Math.ceil(vw / w) + 2;
      if (need < 3) need = 3;

      var clones = rail.querySelectorAll('[data-clone]');
      if (clones.length === need - 1) return;

      clones.forEach(function (c) { c.remove(); });

      var frag = document.createDocumentFragment();
      for (var j = 1; j < need; j++) {
        var c = original.cloneNode(true);
        c.setAttribute('data-clone', '');
        c.querySelectorAll('[data-shopify-editor-block]').forEach(function (eb) {
          eb.removeAttribute('data-shopify-editor-block');
        });
        frag.appendChild(c);
      }
      rail.appendChild(frag);

      watchCards();
    }

    root.addEventListener('mouseenter', function () { root.dataset.hold = '1'; });
    root.addEventListener('mouseleave', function () { root.dataset.hold = '0'; });
    root.addEventListener('touchstart', function () { root.dataset.hold = '1'; }, { passive: true });
    root.addEventListener('touchend', function () {
      setTimeout(function () { root.dataset.hold = '0'; }, 1200);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { offset += 280; });
    if (next) next.addEventListener('click', function () { offset -= 280; });

    viewport.addEventListener('pointerdown', function (e) {
      if (e.button > 0) return;
      down = true;
      captured = false;
      moved = 0;
      lastX = e.clientX;
      velocity = 0;
      /* Remember what was actually under the finger. Pointer capture later
         retargets events to the viewport, which would hide the card. */
      startTarget = e.target;
      root.dataset.pointer = e.pointerId;
    });

    viewport.addEventListener('pointermove', function (e) {
      if (!down) return;

      var dx = e.clientX - lastX;
      lastX = e.clientX;
      moved += Math.abs(dx);

      /* Only start capturing once this is clearly a drag, never on a tap. */
      if (!captured && moved > DRAG_THRESHOLD) {
        captured = true;
        root.classList.add('is-dragging');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
      }

      if (!captured) return;

      offset += dx;
      velocity = dx * 55;
    });

    function endPointer(e) {
      if (!down) return;
      down = false;

      if (captured) {
        root.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(e.pointerId); } catch (err) {}
        captured = false;
        startTarget = null;
        return;
      }

      /* A clean tap. Act on the element the finger started on. */
      if (moved <= DRAG_THRESHOLD && startTarget) {
        var t = startTarget;
        startTarget = null;
        if (t.closest && t.closest('[data-shop]')) return;
        handleTap(t);
      }

      startTarget = null;
    }

    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', function (e) {
      down = false;
      captured = false;
      startTarget = null;
      root.classList.remove('is-dragging');
      try { viewport.releasePointerCapture(e.pointerId); } catch (err) {}
    });

    /* Swallow the click that follows a drag so no video toggles by accident. */
    viewport.addEventListener('click', function (e) {
      if (e.target.closest('[data-shop]')) return;
      e.preventDefault();
      e.stopPropagation();
    });

    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });

    function tick(now) {
      if (lastTime === null) lastTime = now;
      var dt = Math.min((now - lastTime) / 1000, 0.05);
      lastTime = now;

      if (setWidth > 0) {
        if (!captured) {
          if (!isPaused()) offset -= pxPerSec * dt * dir;

          if (Math.abs(velocity) > 2) {
            offset += velocity * dt;
            velocity *= 0.93;
          } else {
            velocity = 0;
          }
        }

        while (offset <= -setWidth) offset += setWidth;
        while (offset > 0) offset -= setWidth;

        rail.style.transform = 'translate3d(' + offset + 'px,0,0)';
      } else {
        build();
      }

      requestAnimationFrame(tick);
    }

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(build);
      ro.observe(original);
      ro.observe(viewport);
    } else {
      window.addEventListener('resize', build);
    }

    original.querySelectorAll('video, img').forEach(function (m) {
      m.addEventListener('loadeddata', build, { once: true });
      m.addEventListener('load', build, { once: true });
    });

    window.addEventListener('load', build);

    var nav = root.querySelector('[data-nav]');
    if (nav) nav.hidden = false;

    build();
    requestAnimationFrame(tick);
  }

  function initAll() {
    document.querySelectorAll('[data-ps-ugc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
